// The full Identification Code Qualifier code list (DE 66) — shared by N103,
// TD502 and every other DE 66 element across transaction sets. Transcribed
// from reference/session/00-envelope-and-common-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const IDENTIFICATION_CODE_QUALIFIER_CODES: CodeListEntry[] = [
  {code: '1', label: 'D-U-N-S Number, Dun & Bradstreet'},
  {code: '2', label: 'Standard Carrier Alpha Code (SCAC)'},
  {code: '9', label: 'D-U-N-S+4, D-U-N-S Number with Four Character Suffix'},
  {code: '15', label: 'Standard Address Number (SAN)'},
  {code: '91', label: "Assigned by Seller or Seller's Agent"},
  {code: '92', label: "Assigned by Buyer or Buyer's Agent"},
  {
    code: '93',
    label: 'Code assigned by the organization originating the transaction set',
  },
  {
    code: '94',
    label:
      'Code assigned by the organization that is the ultimate destination of the transaction set',
  },
  {code: 'UL', label: 'UCC/EAN Location Code (GLN)'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
